 
import appConfig from 'app-config';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { withRetry } from './retryService';

const sendWithRetry = (endpoint, method, params, additionalHeaders) => withRetry(() => JsonRPCService.send(endpoint, method, params, additionalHeaders));

const sessions = {};
const isQnB = appConfig.portalCode === 'QB';

const qnbWrapper = (portalStorageDTOML, resolve, reject, callback) => {
    if (!portalStorageDTOML.jobNumber && !portalStorageDTOML.accountNumber) {
        reject('jobNumber or accountNumber is required');
    }

    const key = portalStorageDTOML.jobNumber || portalStorageDTOML.accountNumber;
    const sessionId = sessions[key];

    if (!sessionId) {
        sendWithRetry(getProxiedServiceUrl('portalstorage'), 'createSession', [key], undefined)
            .then((sessionUUID) => {
                sessions[key] = sessionUUID;
                // eslint-disable-next-line no-param-reassign
                portalStorageDTOML.sessionUUID = sessionUUID;
                callback(sessionUUID).then((data) => {
                    resolve(data);
                }, (error, status, headers) => {
                    reject([error, status, headers]);
                });
            });
    } else {
        callback(sessionId).then((data) => {
            resolve(data);
        }, (error, status, headers) => {
            reject([error, status, headers]);
        });
    }
};

 
const handleStorage = (jobNumber, accountNumber, storageKey, qnbCallback, otherCallback, jsonPayload) => {
    const portalStorageDTOML = {
        jobNumber,
        accountNumber,
        storageKey,
        jsonPayload
    };

    return new Promise((resolve, reject) => {
        if (isQnB) {
            const storeWithSession = (sessionUUID) => {
                portalStorageDTOML.sessionUUID = sessionUUID;

                return qnbCallback(portalStorageDTOML);
            };

            qnbWrapper(portalStorageDTOML, resolve, reject, storeWithSession);
        } else {
            otherCallback(portalStorageDTOML)
                .then((response) => {
                    resolve(response);
                }, (error, status, headers) => {
                    // eslint-disable-next-line prefer-promise-reject-errors
                    reject([error, status, headers]);
                });
        }
    });
};

export default {
    store(jobNumber, accountNumber, storageKey, jsonPayload, additionalHeaders = {}) {
        const qnbStoreCallback = (portalStorageDTOML) => sendWithRetry(getProxiedServiceUrl('portalstorage'), 'storeWithSession',
                [portalStorageDTOML], additionalHeaders);

        const storeCallback = (portalStorageDTOML) => sendWithRetry(getProxiedServiceUrl('portalstorage'), 'store',
                [portalStorageDTOML], additionalHeaders);

        return handleStorage(jobNumber, accountNumber, storageKey,
            qnbStoreCallback, storeCallback, jsonPayload);
    },
    retrieve(jobNumber, accountNumber, storageKey, additionalHeaders = {}) {
        const qnbRetrieveCallback = (portalStorageDTOML) => sendWithRetry(getProxiedServiceUrl('portalstorage'), 'retrieveWithSession',
                [portalStorageDTOML], additionalHeaders);

        const retrieveCallback = (portalStorageDTOML) => sendWithRetry(getProxiedServiceUrl('portalstorage'), 'retrieve',
                [portalStorageDTOML], additionalHeaders);

        return handleStorage(jobNumber, accountNumber, storageKey,
            qnbRetrieveCallback, retrieveCallback);
    }
};
